import { api, LightningElement, wire } from "lwc";
import classNames from "classnames";

import { LabelsAdapter, LabelsAdapterValue } from "common/labelsAdapter";

import * as locales from "./locales";

const ANIMATION_DELAY = 250;

export default class extends LightningElement {
  @api progress: number | null = null;
  @api size: "small" | "medium" | "large" = "medium";
  @api assistiveText: string | null = null;
  @api animation: "on" | "off" = "off";

  private hasRendered: boolean = false;

  private get className() {
    return classNames(`progress-bar progress-bar--${this.size}`, {
      "is-animated": this.animation === "on",
    });
  }

  private get containerStyle() {
    return `
      --progress-min-width: ${this.progress ? "1em" : 0};
      min-width: 6rem;
    `;
  }

  private get valueStyle() {
    return `width: ${this.progress}%`;
  }

  renderedCallback() {
    if (this.hasRendered) return;

    const delay = this.animation === "on" ? ANIMATION_DELAY : 0;

    // Apply styles, but delayed if animation is enabled
    setTimeout(() => {
      this.template
        .querySelector(".progress-bar__value")!
        .setAttribute("style", this.valueStyle);
    }, delay);
  }

  // TODO l10n
  @wire(LabelsAdapter, { locales, options: "$labelOptions" })
  private _labels: LabelsAdapterValue = null!;
  private get labels() {
    return {
      ...this._labels,
      assistive_text: this.assistiveText || this._labels.assistive_text,
    };
  }

  private get labelOptions() {
    return {
      assistive_text: {
        progress: this.progress || 0,
      },
    };
  }
}
